import JourneyProgress from './JourneyProgress';

function JourneyLayout({
  children,
  journeyStep = 0,
  sidebar = null,
  contentClassName = '',
  showJourneySidebar = true,
}) {
  return (
    <div className="min-h-screen bg-white text-gray-900 relative overflow-hidden flex flex-col">
      {/* Background blur effects */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-20 -right-10 w-80 h-80 bg-[#FF6B35]/10 blur-[120px] rounded-full"></div>
        <div className="absolute top-32 -left-10 w-72 h-72 bg-[#1E3A8A]/10 blur-[110px] rounded-full"></div>
        <div className="absolute bottom-0 right-1/3 w-96 h-96 bg-[#FF6B35]/10 blur-[130px] rounded-full"></div>
      </div>

      {/* Content */}
      <div className="relative flex-1 flex flex-col pt-[100px] sm:pt-[110px] md:pt-[120px] lg:pt-[130px] xl:pt-[140px] pb-12 px-4 sm:px-6 lg:px-10">
        <div className={`w-full mx-auto grid gap-8 ${showJourneySidebar ? 'max-w-6xl lg:grid-cols-[minmax(0,1fr)_340px]' : 'max-w-3xl'} items-start`}>
          {/* Main Content */}
          <div
            className={`bg-white border border-gray-200 rounded-3xl p-6 sm:p-8 shadow-xl w-full ${contentClassName}`}
          >
            {children}
          </div>

          {/* Sidebar */}
          {showJourneySidebar && (
            <div className="space-y-4">
              {sidebar}
              <JourneyProgress currentStep={journeyStep} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default JourneyLayout;

